
// const {browserDetection} = require('santa-core-utils')

const isIE = userAgent => 
userAgent && (userAgent.match(/MSIE\s([\d.]+)/) || userAgent.match(/Trident\/[\d](?=[^\?]+).*rv:([0-9.].)/))

module.exports = {isIE}
